import React from "react";
import { BRAND_ASSETS } from "../lib/constants";

/**
 * A thin horizontal strip showing the Ethiopian textile pattern.
 * Used as a decorative divider — restrained use keeps it luxurious.
 */
export const PatternStrip = ({ height = 8, className = "" }) => {
  return (
    <div
      className={`w-full ${className}`}
      style={{
        height: `${height}px`,
        backgroundImage: `url(${BRAND_ASSETS.patternA})`,
        backgroundSize: "auto 100%",
        backgroundRepeat: "repeat-x",
      }}
      aria-hidden="true"
      data-testid="pattern-strip"
    />
  );
};

export default PatternStrip;
